import { useEffect, useState, useCallback } from 'react';
import { initLine } from './lib/liff.js';
import { api } from './lib/api.js';
import { todayStr } from './lib/util.js';
import Shell from './components/Shell.jsx';

/**
 * Boot flow (ก้อน 1-2):
 *   initLine (LIFF/mock) → sync (upsert employee) → getState → render Home
 */
export default function App() {
  const [boot, setBoot] = useState({ status: 'loading' });

  const load = useCallback(async () => {
    setBoot({ status: 'loading' });
    try {
      const { profile, idToken } = await initLine();
      const auth = { idToken: idToken || undefined, lineUserId: profile.userId, displayName: profile.displayName };

      // ก้อน 1: upsert employee ตอน login
      await api('sync', auth);
      // ก้อน 2: ดึง state ของวันนี้
      const state = await api('getState', { ...auth, activityDate: todayStr() });

      setBoot({ status: 'ready', auth, state });
    } catch (err) {
      setBoot({ status: 'error', error: String(err.message || err) });
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (boot.status === 'loading') {
    return (
      <main className="app center splash">
        <img src="/assets/logo.png" alt="Nose Tea" className="brand-logo pulse" />
        <h1 className="brand-name">Nose Tea Move</h1>
        <p className="hint">กำลังเข้าสู่ระบบ…</p>
      </main>
    );
  }
  if (boot.status === 'error') {
    return (
      <main className="app center splash">
        <img src="/assets/logo.png" alt="Nose Tea" className="brand-logo" />
        <p className="err">{boot.error}</p>
        <button className="btn" onClick={load}>ลองใหม่</button>
      </main>
    );
  }

  return <Shell auth={boot.auth} initialState={boot.state} />;
}
